import { FileText, Play } from "lucide-react"
import { useState } from "react"
import type { Media } from "@/shared/lib/types"
import { cn } from "@/shared/lib/utils"

/** Картинка, которая лучше всего представляет материал: обложка каталога, фото или кадр видео. */
export function coverUrl(media: Media[] | undefined): string | null {
	if (!media?.length) return null
	const preview = media.find((item) => item.type === "preview")
	if (preview?.url) return preview.url
	const photo = media.find((item) => item.type === "photo")
	if (photo?.url) return photo.url
	const video = media.find((item) => item.type === "video")
	return video?.thumbnailUrl ?? null
}

/** Миниатюра материала для списков. Без картинки показывает, что внутри: видео или текст. */
export function PostCover({ media, className }: { media?: Media[]; className?: string }) {
	const [failed, setFailed] = useState(false)
	const url = failed ? null : coverUrl(media)
	const hasVideo = media?.some((item) => item.type === "video")
	return (
		<div
			className={cn(
				"relative grid aspect-video shrink-0 place-items-center overflow-hidden rounded-lg bg-muted text-muted-foreground",
				className,
			)}
		>
			{url ? (
				<img
					src={url}
					alt=""
					loading="lazy"
					onError={() => setFailed(true)}
					className="size-full object-cover"
				/>
			) : hasVideo ? (
				<Play className="size-4" />
			) : (
				<FileText className="size-4" />
			)}
			{url && hasVideo ? (
				<span className="absolute right-1 bottom-1 grid size-4 place-items-center rounded-full bg-black/60 text-white">
					<Play className="size-2.5 fill-current" />
				</span>
			) : null}
		</div>
	)
}
